import "./App.css";
import { FeedbackApp } from "./components/FeedbackApp/FeedbackApp.jsx";

function App() {
  return (
    <div className="App">
      <FeedbackApp />
    </div>
  );
}

export default App;
